module.exports = __webpack_public_path__ + "static/img/M4.3f636b54.png";